var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayCircleInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.326 119.639"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "play-circle-instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 45",
    fill: "none",
    d: "M0 0h131.326v119.639H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "play-circle-instagram_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 46",
    fill: "none",
    d: "M0 0h80.019v76.141H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18781"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 280",
    clipPath: "url(#play-circle-instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 133",
    d: "M65.663 115.549a52.224 52.224 0 0052.224-52.223 52.224 52.224 0 00-52.224-52.224 52.224 52.224 0 00-52.224 52.224 52.224 52.224 0 0052.224 52.223z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 284",
    clipPath: "url(#play-circle-instagram_svg__b)",
    transform: "translate(33.935 21.749)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "M67.545 38.256L16.376 8.766a3.549 3.549 0 00-3.906 0 4.028 4.028 0 00-1.954 3.319v58.982a3.78 3.78 0 001.953 3.32 3.776 3.776 0 001.954.585 3.776 3.776 0 001.954-.585l51.169-29.491a4.027 4.027 0 001.954-3.32 3.785 3.785 0 00-1.955-3.321z",
    fill: "currentColor"
  }))))))));
}

export default __webpack_public_path__ + "ef2f58a39e78aeeebaedaf0f14625e89.svg";
export { SvgPlayCircleInstagram as ReactComponent };